module.exports = __webpack_public_path__ + "assets/img/Integrity_badge_Medium_EN.50728f4e.png";